import { httpClient } from '../../../services/http/httpClient.js';
import { buildQueryString, getCollection } from '../../../services/teams/serviceUtils.js';

const TASKS_API_URL = '/api/tasks';
const INACTIVE_TASK_STATUSES = ['finalizada', 'cancelada'];

const hasValidCoordinates = (task) => {
  return task?.client?.lat
    && task?.client?.lng
    && !Number.isNaN(parseFloat(task.client.lat))
    && !Number.isNaN(parseFloat(task.client.lng));
};

export const teamTaskService = {
  getTodayTasks: async (filters = {}) => {
    const queryString = buildQueryString({
      dateType: 'today',
      ...filters
    });
    const payload = await httpClient.get(`${TASKS_API_URL}?${queryString}`);
    return getCollection(payload, ['tasks', 'responses']);
  },

  getActiveTodayTaskCountByTeam: async (teamId) => {
    const tasks = await teamTaskService.getTodayTasks({ team: teamId });
    return tasks.filter((task) => !INACTIVE_TASK_STATUSES.includes(task.status)).length;
  },

  getTodayTasksWithLocation: async (filters = {}) => {
    const tasks = await teamTaskService.getTodayTasks(filters);
    return tasks.filter(hasValidCoordinates);
  }
};
